import React from 'react';
import { Mail, Linkedin, Github, ExternalLink } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { useTranslation } from 'react-i18next';

const Contact = () => {
  const { t } = useTranslation();
  
  const contactMethods = [
    {
      icon: Mail,
      label: t('contact.methods.email.label'),
      value: 'castroluis1694@gmail.com',
      href: 'mailto:castroluis1694@gmail.com',
      description: t('contact.methods.email.desc'),
      color: 'text-blue-600 dark:text-blue-400'
    },
    {
      icon: Linkedin,
      label: t('contact.methods.linkedin.label'),
      value: 'luiscastro94',
      href: 'https://www.linkedin.com/in/luiscastro94/',
      description: t('contact.methods.linkedin.desc'),
      color: 'text-blue-600 dark:text-blue-400'
    },
    {
      icon: Github,
      label: t('contact.methods.github.label'),
      value: 'Castroluis94',
      href: 'https://github.com/Castroluis94',
      description: t('contact.methods.github.desc'),
      color: 'text-slate-700 dark:text-slate-200'
    }
  ];

  return (
    <section id="contact" className="bg-background text-foreground transition-colors duration-300 py-24 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        
        {/* Encabezado de la sección */}
        <div className="mb-14 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 dark:text-white mb-4" style={{ fontFamily: 'IBM Plex Sans, sans-serif' }}>
            {t('contact.title')}
          </h2>
          <div className="w-20 h-1 bg-blue-600 mx-auto rounded"></div>
          <p className="text-lg text-slate-600 dark:text-slate-300 mt-6 max-w-2xl mx-auto">
            {t('contact.description')}
          </p>
        </div>

        {/* Tarjetas de contacto */}
        <div className="grid gap-6">
          {contactMethods.map((method, index) => {
            const IconComponent = method.icon;
            return (
              <Card 
                key={index} 
                className="bg-white dark:bg-slate-900/90 border border-slate-200/80 dark:border-slate-800 shadow-sm hover:shadow-md dark:hover:border-slate-700 transition-all duration-300 group rounded-2xl overflow-hidden"
              >
                <CardContent className="p-0">
                  <a href={method.href} target="_blank" rel="noopener noreferrer" className="flex items-center p-6 gap-6">
                    
                    {/* Contenedor del ícono */}
                    <div className="p-4 bg-slate-100 dark:bg-slate-800/80 rounded-xl group-hover:bg-blue-50 dark:group-hover:bg-blue-950/50 transition-colors">
                      <IconComponent className={`${method.color} group-hover:text-blue-600 dark:group-hover:text-blue-400 transition-colors`} size={28} />
                    </div>

                    {/* Texto principal */}
                    <div className="flex-1">
                      <div className="flex items-center gap-2 mb-1">
                        <p className="text-xs font-bold text-slate-500 dark:text-slate-400 uppercase tracking-wider">{method.label}</p>
                        <ExternalLink size={14} className="text-slate-400 dark:text-slate-500 group-hover:text-blue-600 dark:group-hover:text-blue-400 transition-colors" />
                      </div>
                      <p className="text-xl text-slate-900 dark:text-white font-semibold mb-1">{method.value}</p>
                      <p className="text-sm text-slate-600 dark:text-slate-400">{method.description}</p>
                    </div>

                  </a>
                </CardContent>
              </Card>
            );
          })}
        </div>

      </div>
    </section>
  );
};

export default Contact;